export default {
  bind: function (el, binding) {
    $(el).keypress(isNumber);
  }
}


var isNumber = function(evt) {
  evt = (evt) ? evt : window.event;
  var charCode = (evt.which) ? evt.which : evt.keyCode;
  if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
    evt.preventDefault();;
  } else {
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/directives/only-numbers.js